var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_vm._l((this.numCategories),function(value,index){return _c('box',{key:index,attrs:{"y":-60,"x":_vm.boxPos(index),"name":_vm.categoryNames[index],"boxIndex":index}})}),_c('currentWord',{attrs:{"x":0,"y":-300}}),_c('transition',{attrs:{"name":"fade"}},[(
				this.$store.state.taskContainer.taskMode == 'playing' &&
				this.$store.state.taskContainer.taskPhase == 3
			)?_c('foreignObject',{attrs:{"x":"-790","y":"-495","width":"1580","height":"99"}},[_c('div',{staticClass:"txtbox"},[_c('span',{domProps:{"innerHTML":_vm._s(
						_vm.$parent.text.play.respond(this.categoryNames.length)
					)}})])]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }